import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Element } from 'react-scroll';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Career from './pages/Career';
import Faq from './pages/Faq';
import Gallery from './pages/Gallery';
import NotFoundPage from './pages/NotFoundPage'; // Import your NotFoundPage component
import KandidatList from './pages/KandidatList';
import KandidatDetail from './pages/KandidatDetail';
import ArtikelList from './pages/ArtikelList';
import ArtikelDetail from './pages/ArtikelDetail';
import ChatBot from './components/ChatBot';
import CandidateBanner from './components/CandidateBanner';

const App = () => {
  return (
    <Router>
      {/* Navbar visible on all pages */}
      <Navbar />

      {/* Routes */}
      <Routes>
        {/* Home route with scrollable sections */}
        <Route
          path="/"
          element={
            <>
              <Element name="beranda" id="beranda">
                <Home />
              </Element>
              <CandidateBanner />

              <Element name="layanan" id="layanan">
                <Services />
              </Element>
              <Element name="tentang" id="tentang">
                <About />
              </Element>
              <Element name="galeri" id="galeri">
                <Gallery />
              </Element>
              <Element name="kontak" id="kontak">
                <Contact />
              </Element>
            </>
          }
        />
        {/* Additional standalone pages */}
        <Route path="/karir" element={<Career />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/kandidat" element={<KandidatList />} />
        <Route path="/kandidat/:slug" element={<KandidatDetail />} />
        <Route path="/artikel" element={<ArtikelList />} />
        <Route path="/artikel/:slug" element={<ArtikelDetail />} />

        {/* Catch-all route for unmatched paths */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Footer visible on all pages */}
      <Footer />

      {/* Global floating chatbot */}
      <ChatBot />
    </Router>
  );
};

export default App;
